<div #wrapperEl class="gx-tags" [class.is-disabled]="isEffectivelyDisabled()">
  @for (item of selectedItems(); track item) {
    <span class="gx-token">
      {{ item }}
      <span
        class="text-accent-main hover:bg-accent-interactive-hover duration-fast inline-flex h-[15px] w-[15px] cursor-pointer items-center justify-center rounded-full text-[9px] transition-colors ease-out"
        role="button"
        tabindex="-1"
        [attr.aria-label]="'common.remove' | translate"
        (click)="removeItem(item)"
        (keydown.enter)="removeItem(item)">
        <i [class]="ICONS.x"></i>
      </span>
    </span>
  }
  <input
    type="text"
    class="text-text-primary placeholder:text-text-tertiary min-w-[70px] flex-1 border-none bg-transparent py-0.5 font-sans text-[13px] outline-none"
    [id]="id()"
    [value]="searchText()"
    [placeholder]="placeholder() ?? ''"
    [disabled]="isEffectivelyDisabled()"
    (input)="onSearchInput($event)"
    (keydown)="onKeyDown($event)"
    (focus)="onInputFocus()" />
</div>

<ng-template #panel>
  <div class="g-menu">
    <div class="g-menu-scroll">
      @for (option of filteredOptions(); track option; let i = $index) {
        <div
          class="g-menu-item"
          role="button"
          tabindex="-1"
          [class.is-focused]="i === highlightedIndex()"
          (click)="selectOption(option)"
          (keydown.enter)="selectOption(option)">
          @if (isCustomValue(option)) {
            <i [class]="ICONS.plus"></i>
            <span class="ellipsis">{{ createLabel() }} « {{ option }} »</span>
          } @else {
            <span class="ellipsis">
              <app-highlighted-match [text]="option" [term]="searchText()" />
            </span>
          }
        </div>
      }
    </div>
  </div>
</ng-template>

<app-dropdown
  [target]="wrapper().nativeElement"
  [template]="panel"
  [isOpen]="isOpen()"
  [onClose]="close"
  [useDefaultStyles]="false"
  [offset]="4"
  [minWidth]="wrapperWidth()" />
